import { createInventoryBrandPage } from "../../../components/create-inventory-brand-page";
import db from "../../../utils/parts-vickers.json";
export default createInventoryBrandPage("vickers");

export async function getStaticProps() {
	return { props: { db } };
}
